import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BadgeIntro from './BadgeIntro';
import ClientProvider from './client';
export default createDemo(import.meta.url, BadgeIntro, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/badges/demos/intro/BadgeIntro.tsx",
    "fileName": "BadgeIntro.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import IconButton from '@mui/material/IconButton';\nimport Badge from '@mui/material/Badge';\nimport MailIcon from '@mui/icons-material/Mail';\n\nconst maxVisibleNotifications = 99;\nconst unreadNotificationsCount = 100;\n\nfunction getUnreadNotificationsLabel(count: number) {\n  if (count === 0) {\n    return 'show no unread notifications';\n  }\n  if (count > maxVisibleNotifications) {\n    return `show more than ${maxVisibleNotifications} unread notifications`;\n  }\n  return `show ${count} unread notification${count === 1 ? '' : 's'}`;\n}\n\nexport default function BadgeIntro() {\n  const label = getUnreadNotificationsLabel(unreadNotificationsCount);\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <IconButton aria-label={label}>\n      <Badge\n        badgeContent={unreadNotificationsCount}\n        color=\"secondary\"\n        max={maxVisibleNotifications}\n      >\n        <MailIcon />\n      </Badge>\n    </IconButton>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 32,
        "focusedLines": 9,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import IconButton from '@mui/material/IconButton';\nimport Badge from '@mui/material/Badge';\nimport MailIcon from '@mui/icons-material/Mail';\n\nconst maxVisibleNotifications = 99;\nconst unreadNotificationsCount = 100;\n\nfunction getUnreadNotificationsLabel(count: number) {\n  if (count === 0) {\n    return 'show no unread notifications';\n  }\n  if (count > maxVisibleNotifications) {\n    return `show more than ${maxVisibleNotifications} unread notifications`;\n  }\n  return `show ${count} unread notification${count === 1 ? '' : 's'}`;\n}\n\nexport default function BadgeIntro() {\n  const label = getUnreadNotificationsLabel(unreadNotificationsCount);\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <IconButton aria-label={label}>\n      <Badge\n        badgeContent={unreadNotificationsCount}\n        color=\"secondary\"\n        max={maxVisibleNotifications}\n      >\n        <MailIcon />\n      </Badge>\n    </IconButton>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "badgeContent"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "unreadNotificationsCount"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "maxVisibleNotifications"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "MailIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 32,
    "focusedLines": 9,
    "collapsible": true,
    "externals": [
      "@mui/material/IconButton",
      "@mui/material/Badge",
      "@mui/icons-material/Mail"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
